import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { TangibilitySection } from '../components/TangibilitySection';
import { SocialProofAuthorityBox } from '../components/SocialProofAuthorityBox';
import { SocialProofSection } from '../components/SocialProofSection';
import { SuccessInsert } from '../components/SuccessInsert';
import { ConnectionInsert } from '../components/ConnectionInsert';
import { ValueSummaryTable } from '../components/ValueSummaryTable';
import { BundleSection } from '../components/BundleSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmpathySection } from '../components/EmpathySection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-charcoal relative overflow-x-hidden" data-id="element-372">
      <AnnouncementBar data-id="element-373" />
      <HeroSection data-id="element-374" />
      <TangibilitySection data-id="element-375" />
      <SocialProofAuthorityBox data-id="element-376" />
      <SocialProofSection data-id="element-377" />
      <SuccessInsert data-id="element-378" />
      <ConnectionInsert data-id="element-379" />
      <ValueSummaryTable data-id="element-380" />
      <BundleSection data-id="element-381" />
      <TestimonialsSection data-id="element-382" />
      <EmpathySection data-id="element-383" />
      <OrderBumpSection data-id="element-384" />
      <FAQSection data-id="element-385" />
      <Footer data-id="element-386" />
      <StickyButton data-id="element-387" />
    </main>;
}